import * as React from 'react';

import { createDrawerNavigator } from '@react-navigation/drawer';
import DrawerUi from "../components/DrawerUi";
import HomeScreen from "../screens/HomeScreen";
import {wp} from "../utils/responsive";
import {strings} from "../theme/strings";


const Drawer = createDrawerNavigator();

export default function DrawerNav() {
    return <Drawer.Navigator
        headerMode='none'
        drawerPosition='right'
        drawerStyle={{width:wp(80)>300?300:wp(80)}}
        drawerContent={(props) => <DrawerUi {...props} />}
        initialRouteName="Home">
        <Drawer.Screen name="Home" component={HomeScreen} options={{ title: strings.asanDarman }} />

    </Drawer.Navigator>
}

